module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/system-level-setting/managerAssignment/managerAssignment.component.html
// module id = 1288
// module chunks = 10